import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleOneSectionTitle from './StyleOneSectionTitle'
import { topicTeacherImgs } from '../../images/topicImg'

export class StyleOneAdvantage extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { itemsData } = this.props;
    return (
      <div className="topic-style-one-advantage" style={{ background: `url(${itemsData.totalbackImg}) no-repeat`}}>
        <div className='advantage_container'>
          <a name={itemsData.name}><StyleOneSectionTitle Data={itemsData} isColorW={true} /></a>
          <div className='advantage_content flex_row'>
            {itemsData.list && itemsData.list.map(item => <div className='flex_row' style={{alignItems: 'center'}} key={item.id}><div className={item.id === 2 ? 'advantage_item red flex_row' : 'advantage_item flex_row'}>
              <div className={item.id === 2 ? 'advantage_number red' : 'advantage_number yellow'}>{item.id}</div>
              <div className='advantage_item_box'>
                <div className='item_title'>{item.title}</div>
                <div className='item_tips'>{item.subtitle}</div>
                <div className='item_tips'>{item.tips}</div>
              </div>
            </div>{item.id < 4 && <img src={topicTeacherImgs.industry_add} alt="" />}</div>)}
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneAdvantage);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneAdvantage.js